import React, { useEffect, useState } from "react";
import VehiclesDashboard from "./VehiclesDashboard";
import VehiclesList from "./VehiclesList";
import VehicleForm from "./VehicleForm";
import { addVehicle, updateVehicle } from "../services/vehicleService";
import { LayoutDashboard, List, ArrowLeft } from "lucide-react";

const VehiclesPage = ({ type }) => {
  console.log(type);

  const [currentView, setCurrentView] = useState("dashboard");
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const showNotification = (message, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 5000);
  };

  const handleAddVehicle = () => {
    setSelectedVehicle(null);
    setCurrentView("add");
  };

  const handleEditVehicle = (vehicle) => {
    setSelectedVehicle(vehicle);
    setCurrentView("edit");
  };

  const handleFormSubmit = async (vehicleData) => {
    setLoading(true);
    try {
      if (selectedVehicle) {
        // Update existing vehicle
        await updateVehicle(selectedVehicle.id, vehicleData);
        showNotification("Vehicle updated successfully!");
      } else {
        // Add new vehicle
        await addVehicle(vehicleData);
        showNotification("Vehicle added successfully!");
      }
      setCurrentView("list");
      setSelectedVehicle(null);
    } catch (error) {
      showNotification(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setCurrentView("list");
    setSelectedVehicle(null);
  };

  const renderContent = () => {
    switch (currentView) {
      case "dashboard":
        return <VehiclesDashboard />;
      case "list":
        return (
          <VehiclesList
            onAddVehicle={handleAddVehicle}
            onEditVehicle={handleEditVehicle}
          />
        );
      case "add":
      case "edit":
        return (
          <VehicleForm
            vehicle={selectedVehicle}
            onSubmit={handleFormSubmit}
            onCancel={handleCancel}
            isLoading={loading}
          />
        );
      default:
        return (
          <VehiclesList
            onAddVehicle={handleAddVehicle}
            onEditVehicle={handleEditVehicle}
          />
        );
    }
  };
  useEffect(() => {
    if(type)
    setCurrentView(type);
  }, [type]);
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* View Toggle */}
            <div className="flex items-center gap-4">
              {(currentView === "add" || currentView === "edit") && (
                <button
                  onClick={handleCancel}
                  className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Back
                </button>
              )}

              {(currentView === "dashboard" || currentView === "list") && (
                <div className="flex items-center bg-gray-100 rounded-lg p-1">
                  <button
                    onClick={() => setCurrentView("dashboard")}
                    className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      currentView === "dashboard"
                        ? "bg-white text-blue-600 shadow-sm"
                        : "text-gray-600 hover:text-gray-900"
                    }`}
                  >
                    <LayoutDashboard className="w-4 h-4" />
                    Dashboard
                  </button>
                  <button
                    onClick={() => setCurrentView("list")}
                    className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      currentView === "list"
                        ? "bg-white text-blue-600 shadow-sm"
                        : "text-gray-600 hover:text-gray-900"
                    }`}
                  >
                    <List className="w-4 h-4" />
                    List View
                  </button>
                </div>
              )}
            </div>

            {/* Page Title */}
            <div className="flex-1 text-center">
              <h1 className="text-lg font-semibold text-gray-900">
                {currentView === "dashboard" && "Vehicle Dashboard"}
                {currentView === "list" && "All Vehicles"}
                {currentView === "add" && "Add New Vehicle"}
                {currentView === "edit" && "Edit Vehicle"}
              </h1>
            </div>

            {/* Spacer for centering */}
            <div className="w-32"></div>
          </div>
        </div>
      </div>

      {/* Notification */}
      {notification && (
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4`}>
          <div
            className={`p-4 rounded-md ${
              notification.type === "success"
                ? "bg-green-50 border border-green-200 text-green-800"
                : "bg-red-50 border border-red-200 text-red-800"
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium">
                {notification.message}
              </span>
              <button
                onClick={() => setNotification(null)}
                className="text-gray-400 hover:text-gray-600"
              >
                <span className="sr-only">Close</span>
                <svg
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {renderContent()}
      </div>
    </div>
  );
};

export default VehiclesPage;
